import { combineReducers } from '@reduxjs/toolkit';
import onboardingBasicReducer from './onboardingSlice';
import generalInfoReducer from './Pages/GeneralInfo/generalInfoReducer';
import servicesReducer from './Pages/Services/servicesSlice';
import mediaReducer from './Pages/Media/mediaSlice';
import additionalInfoReducer from './Pages/AdditionalInfo/additionalInfoSlice';
import configurationReducer from './Pages/Configuration/configurationSlice';
import publicationReducer from './Pages/Publication/publicationSlice';

export const onboardingReducer = combineReducers({
  basic: onboardingBasicReducer,
  generalInfo: generalInfoReducer,
  services: servicesReducer,
  media: mediaReducer,
  additional: additionalInfoReducer,
  configuration: configurationReducer,
  publication: publicationReducer,
})

export default onboardingReducer